import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#features", label: "核心功能" },
  { href: "#categories", label: "漫画分类" },
  { href: "#popular", label: "热门推荐" },
  { href: "#devices", label: "多端支持" },
  { href: "#reviews", label: "用户口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-emotion-laugh-line text-xl" />
          </span>
          <span className="font-heading text-xl text-foreground-950">
            香蕉漫画
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 md:inline-block"
          >
            下载APP
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 backdrop-blur-md md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-lg px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              下载APP
            </a>
          </div>
        </div>
      )}
    </header>
  );
}